import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { Grid, Stack } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { InstagramSettingsDto } from '../../social-export.types';

export const instagramSettingsSchema = z.object({
  shareToFeed: z.boolean().nullable().optional(),
});

const shareToFeedMessage = defineMessage({
  id: 'socialExport.form.shareToFeed',
  defaultMessage: 'Compartir también en el feed',
});

export function InstagramSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<InstagramSettingsDto>) {
  const { $t } = useIntl();
  return (
    <PlatformSettingsFormShell
      values={{
        shareToFeed: defaultSettings?.shareToFeed ?? true,
      }}
      schema={instagramSettingsSchema}
      onSuccess={async (formData) => {
        await onUpdate({
          shareToFeed: formData.shareToFeed ?? null,
        });
      }}
    >
      <Grid container>
        <Grid item md={4}>
          <Stack spacing={2}>
            <SwitchElement name="shareToFeed" label={$t(shareToFeedMessage)} color="primary" />
          </Stack>
        </Grid>
      </Grid>
    </PlatformSettingsFormShell>
  );
}
